/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-, tab- or space-separated rows, with the first column as x-axis labels and numeric columns as series; an all-text first row is the legend header.`)
};

const es_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas separadas por comas, tabulaciones o espacios, con la primera columna como etiquetas del eje X y las columnas numéricas como series; una primera fila totalmente de texto es la cabecera de leyenda.`)
};

const de_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durch Kommas, Tabulatoren oder Leerzeichen getrennte Zeilen, mit der ersten Spalte als x-Achsen-Beschriftungen und numerischen Spalten als Serien; eine reine Text-Kopfzeile ist die Legenden-Kopfzeile.`)
};

const nl_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komma-, tab- of spatiegescheiden rijen, met de eerste kolom als x-as-labels en numerieke kolommen als reeksen; een eerste rij die volledig uit tekst bestaat is de legendaheader.`)
};

const fr_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des lignes séparées par des virgules, des tabulations ou des espaces, avec la première colonne comme étiquettes de l'axe des x et les colonnes numériques comme séries ; une première ligne entièrement textuelle sert d'en-tête de légende.`)
};

const it_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righe separate da virgole, tabulazioni o spazi, con la prima colonna come etichette dell'asse x e le colonne numeriche come serie; una prima riga interamente testuale è l'intestazione della legenda.`)
};

const pt_br2_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas separadas por vírgula, tabulação ou espaço, com a primeira coluna como rótulos do eixo x e colunas numéricas como séries; uma primeira linha totalmente textual é o cabeçalho da legenda.`)
};

const pt_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linhas separadas por vírgulas, tabulações ou espaços, com a primeira coluna como rótulos do eixo X e colunas numéricas como séries; uma primeira linha totalmente textual é o cabeçalho da legenda.`)
};

const ja_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンマ、タブ、またはスペース区切りの行で、最初の列がx軸ラベル、数値列が系列になります。すべて文字の最初の行は凡例のヘッダーです。`)
};

const zh_area_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以逗号、制表符或空格分隔的行，第一列为 x 轴标签，数值列为系列；如果第一行全为文本，则作为图例表头。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_faq_a3", locale)
	if (locale === "en") return en_area_faq_a3(inputs)
	if (locale === "es") return es_area_faq_a3(inputs)
	if (locale === "de") return de_area_faq_a3(inputs)
	if (locale === "nl") return nl_area_faq_a3(inputs)
	if (locale === "fr") return fr_area_faq_a3(inputs)
	if (locale === "it") return it_area_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_area_faq_a3(inputs)
	if (locale === "pt") return pt_area_faq_a3(inputs)
	if (locale === "ja") return ja_area_faq_a3(inputs)
	return zh_area_faq_a3(inputs)
};